/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PreAuthFunnelCounts interface.
 */
export function instanceOfPreAuthFunnelCounts(value) {
    if (!('contentScriptInjected' in value) || value['contentScriptInjected'] === undefined)
        return false;
    if (!('extensionInstalled' in value) || value['extensionInstalled'] === undefined)
        return false;
    if (!('firstAiGenerationCompleted' in value) || value['firstAiGenerationCompleted'] === undefined)
        return false;
    return true;
}
export function PreAuthFunnelCountsFromJSON(json) {
    return PreAuthFunnelCountsFromJSONTyped(json, false);
}
export function PreAuthFunnelCountsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contentScriptInjected': json['contentScriptInjected'],
        'extensionInstalled': json['extensionInstalled'],
        'firstAiGenerationCompleted': json['firstAiGenerationCompleted'],
    };
}
export function PreAuthFunnelCountsToJSON(json) {
    return PreAuthFunnelCountsToJSONTyped(json, false);
}
export function PreAuthFunnelCountsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'contentScriptInjected': value['contentScriptInjected'],
        'extensionInstalled': value['extensionInstalled'],
        'firstAiGenerationCompleted': value['firstAiGenerationCompleted'],
    };
}
